var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticClass: "footer-wrapper" },
    [
      _c(
        "el-col",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "center",
            "align-items": "center",
            padding: "40px 0 45px 0"
          },
          attrs: { span: 24 }
        },
        [
          _c("img", {
            staticStyle: { width: "250px", height: "48px" },
            attrs: {
              alt: "UNIFI Property",
              src: require("../../../../assets/unifi-logo-new-with-text-white.svg")
            },
            on: { click: _vm.redirectToHome }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-row",
            { staticStyle: { padding: "40px 15px" } },
            [
              _c(
                "el-col",
                {
                  staticClass: "centered-social-icon",
                  staticStyle: { gap: "30px" },
                  attrs: { sm: 24, span: 24, xs: 24 }
                },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.facebook.com/unifiproperty",
                        target: "_blank"
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          alt: "Facebook",
                          src: require("../../../../assets/facebook48x48.png")
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.instagram.com/unifiproperty/",
                        target: "_blank"
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          alt: "Instagram",
                          src: require("../../../../assets/instagram48x48.png")
                        }
                      })
                    ]
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("el-col", { attrs: { span: 24 } }, [
        _c("div", { staticClass: "footer-copyright-wrapper" }, [
          _c(
            "span",
            {
              staticClass: "footer-copyright-text",
              staticStyle: { padding: "10px 0" }
            },
            [
              _vm._v(
                "© " +
                  _vm._s(new Date().getFullYear()) +
                  " UNIFI Property, All rights\n          reserved"
              )
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-712ae985", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-712ae985","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/uConnectRegistration/steps/stepsFooter.vue
// module id = null
// module chunks = 